export default {
    init() {
        // JavaScript to be fired on the home page
        // console.log(window.location.pathname);
        if (window.location.hash != '') {
            setTimeout(() => {
                $(window.location.hash).modal('show');
            }, 500);
            $(window.location.hash).on('hidden.bs.modal', function () {
                history.replaceState(null, null, ' ');
            });
        }
    },
    finalize() {
        // JavaScript to be fired on the home page, after the init JS
    },
};



// WEBPACK FOOTER //
// ./scripts/routes/modal-trigger.js